import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class SortCodeField extends Field<string> {
  constructor(
    model: Merchant,
    { propertyName }: { propertyName: string },
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "12-34-56",
      propertyName,
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.lead.salesChannel.value;
    if (this.propertyName === "sortCode2") {
      if (
        registeredCountry === "United Kingdom" &&
        hasInstoreChannel(salesChannel)
      ) {
        return true;
      }
    } else {
      if (registeredCountry === "United Kingdom") {
        return true;
      }
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (typeof this.value === "undefined") {
      return;
    }

    const formatRegex = /\d{2}-\d{2}-\d{2}/;
    if (!formatRegex.test(this.value)) {
      const msg = "Invalid sort code. Must be in the format 12-34-56.";
      throw new FieldError(this, msg, "InvalidFormat");
    }
  }
}
